import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "34",
  height: "42",
  viewBox: "0 0 34 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "presentation"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.1533 40.6167L18.0957 40.6594C17.6688 40.9759 17.1569 41.0389 16.7436 40.98C16.332 40.9213 15.8594 40.7189 15.5386 40.298C15.5376 40.2967 15.5366 40.2954 15.5356 40.2941L4.20889 25.5901C4.20861 25.5897 4.20832 25.5893 4.20804 25.589C2.16477 22.9458 1 19.7582 1 16.3818C1 7.8544 8.23894 1 17 1C25.7611 1 33 7.8544 33 16.3818C33 19.758 31.8353 22.9456 29.7922 25.5886L18.1533 40.6167ZM18.1533 40.6167L18.2042 40.5661L18.3714 40.4003L18.4187 40.3534L18.4594 40.3006L29.7911 25.5901L18.1533 40.6167Z",
  fill: "#248096",
  stroke: "white",
  "stroke-width": "2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21.9133 14.4036V9.58869C21.9133 9.14877 21.559 8.79447 21.1185 8.79447H19.5306C19.5306 8.35455 19.1763 8.00024 18.7358 8.00024H14.7653C14.3254 8.00024 13.9711 8.35455 13.9711 8.79447H12.3827C11.9427 8.79447 11.5884 9.14877 11.5884 9.58869V14.4036L10 15.1482L11.5884 18.325V19.9135L14.1201 20.6581C14.207 20.6866 14.2845 20.7071 14.3683 20.7071C14.4521 20.7071 14.5433 20.6798 14.6165 20.6581L16.751 19.9135L18.8856 20.6581C18.9675 20.6854 19.05 20.7077 19.1338 20.7077C19.2175 20.7077 19.3038 20.6823 19.382 20.6581L21.9136 19.9135V18.325L23.5015 15.1482L21.9133 14.4036ZM20.3249 13.659L17.5451 12.3684L16.7509 11.9713L15.9566 12.3684L13.1769 13.659V10.3828H20.3249V13.659Z",
  fill: "white"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.5884 21.502C11.5041 21.502 11.3961 21.5293 11.3402 21.5516L10 21.9977V23.6116L11.5884 23.0904L14.1201 23.8356C14.207 23.8641 14.2845 23.8846 14.3683 23.8846C14.4521 23.8846 14.5433 23.8585 14.6165 23.8356L16.751 23.0904L18.8856 23.8356C18.9675 23.8629 19.05 23.8846 19.1338 23.8846C19.2175 23.8846 19.3038 23.8598 19.382 23.8356L21.9136 23.0904L23.5015 23.6116L23.5021 21.9977L22.1618 21.551C22.083 21.5249 21.9974 21.502 21.9136 21.502C21.8299 21.502 21.7461 21.5249 21.6654 21.5516L19.1338 22.2956L16.9992 21.551C16.9155 21.5237 16.8348 21.502 16.751 21.502C16.6673 21.502 16.5785 21.5274 16.5028 21.5516L14.3683 22.2956L11.8366 21.551C11.7343 21.5125 11.6728 21.502 11.5884 21.502L11.5884 21.502Z",
  fill: "white"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }